import React from 'react';
import { useTranslation } from 'react-i18next';
import { KeyMapKeys } from '@locales/lokalise/keyMap';
import cn from 'classnames';

interface IHintMessageProps {
  valid?: boolean;
  message: string;
}

export const HintMessage = ({ message, valid }: IHintMessageProps) => {
  const { i18n } = useTranslation();

  return (
    <div className={cn('form__hint', { form__hint_error: !valid })}>
      {i18n.exists(message) ? i18n.t(message as KeyMapKeys) : message}
    </div>
  );
};
